import A11yDialog from 'a11y-dialog'

import { onElements } from './dom.js'
import { readStorage, writeStorage } from './storage.js'

function storageKey(id) {
    return `modal-seen:${id}`
}

const dialogs = new Map()
let openDialog = null

export const getDialog = (id) => dialogs.get(id)

// The container element of the dialog currently open, if any.
export const getOpenDialogElement = () => openDialog?.$el ?? null

function initDialog(container) {
    if (container.dataset.dialogInitialized) return
    container.dataset.dialogInitialized = 'true'

    const title = container.querySelector('[data-dialog-title]')
    if (title) {
        title.id = title.id || `${container.id}-title`
        container.setAttribute('aria-labelledby', title.id)
    }

    // a11y-dialog's implicit closer matching breaks with >1 closer per dialog.
    container.querySelectorAll('[data-a11y-dialog-hide]').forEach((closer) => {
        closer.setAttribute('data-a11y-dialog-hide', container.id)
    })

    const dialog = new A11yDialog(container)
    dialogs.set(container.id, dialog)
    dialog.on('show', () => (openDialog = dialog))
    dialog.on('hide', () => {
        if (openDialog === dialog) openDialog = null
    })

    if ('dialogOnce' in container.dataset) {
        if (!readStorage(storageKey(container.id))) {
            dialog.show()
        }
        dialog.on('hide', () => {
            writeStorage(storageKey(container.id), '1')
        })
        return
    }

    if ('dialogAutoshow' in container.dataset) {
        dialog.show()
    }
}

// Including any htmx adds to the page later (e.g. game_finished_modal)
onElements('[data-dialog]', initDialog)
